import { NextSeoProps } from 'next-seo';

import { SourceDomain } from '@pflegia/types/api/source-domain/source-domain';
import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';
import SharedNextSeo from '@pflegia/ui/shared/next-seo';
import { getPflegiaDefaultDomainName } from '@pflegia/ui/shared/utils/get-pflegia-default-domain';

/**
 * @deprecated use NextSeo from libs/ui/shared instead
 */
const NextSeo: React.FC<NextSeoProps & { flavorDomain?: string }> = props => {
  const { sourceDomain } = useFlavorFromRoute();

  return <SharedNextSeo defaultDomain={SourceDomain.PflegiaDe} flavorDomain={getPflegiaDefaultDomainName(sourceDomain)} {...props} />;
};
export default NextSeo;
